/// <reference types="./Context.d.ts" />
import { TransactionContextImpl, } from '@dossierhq/database-adapter';
export class InternalContextImpl extends TransactionContextImpl {
    constructor(databaseAdapter, logger, databasePerformance, transaction = null) {
        super(databaseAdapter, logger, databasePerformance, transaction);
    }
    copyWithNewTransaction(databaseAdapter, transaction) {
        return new InternalContextImpl(databaseAdapter, this.logger, this.databasePerformance, transaction);
    }
}
export class SessionContextImpl extends TransactionContextImpl {
    session;
    defaultAuthKeys;
    constructor(session, defaultAuthKeys, databaseAdapter, logger, databasePerformance, transaction = null) {
        super(databaseAdapter, logger, databasePerformance, transaction);
        this.session = session;
        this.defaultAuthKeys = defaultAuthKeys;
    }
    copyWithNewTransaction(databaseAdapter, transaction) {
        return new SessionContextImpl(this.session, this.defaultAuthKeys, databaseAdapter, this.logger, this.databasePerformance, transaction);
    }
}
//# sourceMappingURL=Context.js.map